import React, { Component } from 'react';
import _ from 'lodash';

import AddExamsList from '../../Components/AddExamsList';

/**
 * Convert data from AddExamList form to examsInput format
 * @param {Object} formData in form of {subjectCodeA: true, subjectCodeB: false}
 * @return in form of [ {subjectCode: subjectCodeA},{ subjectCode: subjectCodeB } ]
 */
const formDataToExamsInput = formData => {
  return Object.entries(formData)
    .filter(([key, value]) => value === true)
    .map(([key]) => ({ subjectCode: key }));
};

const handleSubmit = (data, roundCode, addExams) => {
  if (data === undefined || data === null) {
    return null;
  }
  const examsInput = formDataToExamsInput(data);

  if (examsInput.length > 0) {
    return addExams({ variables: { roundCode, examsInput } });
  } else {
    return null;
  }
};

export default class AddStudentExamWithCloseCallback extends Component {
  componentDidUpdate = prevProps => {
    const { data, onClose } = this.props;
    if (
      !_.isEqual(prevProps.data, data) &&
      _.get(data, 'addMockExamStudentExams.success') === true
    ) {
      onClose();
    }
  };

  render = () => {
    const { onClose, displayError, exams, roundCode, mutation } = this.props;

    return (
      <AddExamsList
        onCloseModal={onClose}
        exams={exams}
        displayError={displayError}
        onSubmit={form => handleSubmit(form, roundCode, mutation)}
      />
    );
  };
}
